import { AppError, useAppErrorMessages } from '@multaqa/ui/components/async/app-error'
import { FormSkeleton } from '@multaqa/ui/components/async/form-skeleton'
import { useCompanySettings } from './api'
import { CompanyApprovalsCard } from './company-settings-approvals'
import { CompanyPurchasingCard } from './company-settings-purchasing'
import {
  CompanyBrandingCard,
  CompanyHrCard,
  CompanyWarehousingCard,
} from './company-settings-read-only'
import { CompanyTimeZoneCard } from './company-settings-time-zone'

export function CompanySettings({ groupId, companyId }: { groupId: string; companyId: string }) {
  const settings = useCompanySettings(groupId, companyId)
  const messages = useAppErrorMessages()

  if (settings.isLoading) return <FormSkeleton fields={8} />
  if (settings.isError || !settings.data) {
    return <AppError error={settings.error} messages={messages} retry={settings.refetch} />
  }

  return (
    <div className="grid gap-4" data-testid="company-settings">
      <CompanyTimeZoneCard groupId={groupId} companyId={companyId} settings={settings.data} />
      <CompanyPurchasingCard groupId={groupId} companyId={companyId} settings={settings.data} />
      <CompanyApprovalsCard groupId={groupId} companyId={companyId} settings={settings.data} />
      <CompanyHrCard groupId={groupId} companyId={companyId} settings={settings.data} />
      <CompanyBrandingCard groupId={groupId} companyId={companyId} settings={settings.data} />
      <CompanyWarehousingCard settings={settings.data} />
    </div>
  )
}
